module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-70.a28fbf7d.svg";